module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d2-d5f88a5f148ed-d1e230"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head "
  }, [_c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("Recent titles by Mitch Silver")])])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text "
  }, [_vm._v("IN SECRET SERVICE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text "
  }, [_vm._v("THE BOOKWORM")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after "
  }, [_vm._v("THE APOLLO DECEPTION *"), _c('em', [_c('em', {
    staticClass: "char-italic italic"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text "
  }, [_c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("* available from Severn House")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ca0ab6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781448303595_epub_alb.vue
// module id = 60
// module chunks = 0